import React from 'react';

const GraphLineIcon = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 24 24" ref={svgRef} {...props} width="1em" height="1em">
    <title>{title}</title>
    <defs>
      <style>{'.analytics-board-graph-line_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}'}</style>
    </defs>
    <rect className="analytics-board-graph-line_svg__a" x={0.75} y={3.75} width={22.5} height={16.5} rx={1.5} ry={1.5} />
    <path className="analytics-board-graph-line_svg__a" d="M3.75 15L6.9 9.75 9.75 15l3-3 3 3 4.5-6.75" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <GraphLineIcon svgRef={ref} {...props} />);
export default ForwardRef;
